class ComponentSearch extends HTMLElement {
  constructor() {
    super();
    // return;
    this.searchField = this.querySelector('input[name="q"]');
    this.results = this.querySelector('.search-results');
    this.form = this.querySelector('form');
    this.searchDelay = 300;
    this.searchType = 'product';
    this.controller = null;
    this.requestTimeout = 0;
    this.predictiveSearch = this.dataset.predictiveSearch=='true';
    this.wildcard = this.dataset.wildcard=='true' ? '*' : '';
    this.showPrice = this.dataset.showPrice=='true';

    if (this.dataset.autocomplete == "true") {
      if (this.predictiveSearch) {
        this.searchType = 'product';
      }
      this.documentClickHandler = this.documentClick.bind(this);
      this.searchField.addEventListener('input', this.doSearch.bind(this));
      this.searchField.addEventListener('focus', ()=> {
        if (!this.resultsVisible) {
          this.searchField.dispatchEvent(new CustomEvent('input'));
        }
      });
    } 

    this.form.addEventListener('submit', (e)=>{
      e.preventDefault();
      const formData = new FormData(this.form);
      const searchParams = new URLSearchParams(formData);
      const query = searchParams.get('q');
      if(query && query!="") {
        searchParams.set('q', this.wildcard + query + this.wildcard);
        location = this.form.action + '?' + searchParams.toString();
      }
    });
  }

  //term param allows to trigger custom search from js code.
  doSearch(term) {
    var query = (typeof(term)=="string" ? term : this.searchField.value).trim();
    if (this.controller) {
      this.controller.abort();
      this.controller = null;
    }
    clearTimeout(this.requestTimeout);
    if (query.length>=4) {
      this.showSearchingResults();
      this.requestTimeout = setTimeout(()=>{
        this.controller = new AbortController();
        var searchUrl = '/search?q='+ encodeURIComponent(query) + '&type=product&section_id=search_standard_json';
        $s.get({
          signal: this.controller.signal,
          url: searchUrl,
          success: (data)=>{
            if (!this.resultsVisible) {
              return;
            }
            var parser = new DOMParser();
            var doc = parser.parseFromString(data, "text/html");
            var jsonNode = doc.querySelector('#shopify-section-search_standard_json') || doc.querySelector('div');
            var jsonString = jsonNode ? (jsonNode.textContent || jsonNode.innerHTML || '') : '';
            try {
              var response = JSON.parse(jsonString);
            } catch (error) {
              jsonString = jsonString.replace(/"thumbnail":\s*Liquid error[^,}]*/g, '"thumbnail": ""');
              try {
                var response = JSON.parse(jsonString);
              } catch (secondError) {
                console.error('Could not parse search response even after cleanup:', secondError);
                this.noResults();
                return;
              }
            }
            this.clearResults(false);
            var products = Array.isArray(response.results) ? response.results : [];
            var collections = Array.isArray(response.collections) ? response.collections : [];
            if (products.length > 0 || collections.length > 0) {
              var title = document.createElement('div'); 
              title.innerHTML = "Search results";
              title.classList.add('visually-hidden');
              this.results.appendChild(title);
              var items = document.createElement('div');
              items.classList.add('search-results-items');
              this.results.appendChild(items);
              if (products.length > 0) {
                var group = document.createElement('div');
                group.classList.add('search-results-product', 'search-results-group');
                var title = document.createElement('div');
                items.appendChild(title);
                title.outerHTML = '<div class="result-group-title-wrapper"><div class="result-group-title">Products</div></div>'
                items.appendChild(group);
                products.forEach((item)=>{
                  group.appendChild(this.buildItem(item));
                });
              }
              if (collections.length > 0) {
                var group = document.createElement('div');
                group.classList.add('search-results-collections', 'search-results-group');
                var title = document.createElement('div');
                items.appendChild(title);
                title.outerHTML = '<div class="result-group-title-wrapper"><div class="result-group-title">Collections</div></div>'
                items.appendChild(group);
                collections.forEach((item)=>{
                  group.appendChild(this.buildItem(item));
                });
              }
              if (products.length > 0 && collections.length > 0) {
                items.classList.add('multi-category');
              }
              if (response.results_count > products.length) {
                var linkUrl = '/search?q='+ encodeURIComponent(query) + '&type=product';
                this.results.appendChild(this.buildSeeAllLink(linkUrl, response.results_count));
              }
            } else {
              this.noResults();
            }
          }
        });
      }, this.searchDelay);
    } else {
      this.clearResults();
    }
  }

  buildItem(itemJson) {
    var img = document.createElement('img');
    var info = document.createElement('div');
    var title = document.createElement('div');
    var a = document.createElement('a');
    a.classList.add("result-item", "flex", "direction-row", "justify-content-start", "align-items-start");
    a.href = itemJson.url;
    // Handle cases where thumbnail might be empty, undefined, or contain error messages
    if (itemJson.thumbnail && itemJson.thumbnail.trim() !== '' && !itemJson.thumbnail.includes('Liquid error')) {
      img.src = itemJson.thumbnail;
    } else {
      img.src = '';
      img.style.display = 'none'; // Hide image if no valid thumbnail
    }
    img.alt = '';
    title.classList.add('title');
    title.innerHTML = itemJson.title;
    a.appendChild(img);
    a.appendChild(info);
    info.appendChild(title);
    info.classList.add('info');
    // console.log("sku: ", itemJson.sku);
    // if (itemJson.sku) {
    //   var sku = document.createElement('div');
    //   sku.classList.add('sku');
    //   sku.textContent = itemJson.sku;
    //   info.appendChild(sku);
    // }
    if (this.showPrice && itemJson.price != undefined) {
      var price = document.createElement('div');
      price.classList.add('price', 'money');
      price.innerHTML = $s.formatMoney(itemJson.price).replace('.00', '');
      info.appendChild(price);
    }
    return a;
  }

  buildSeeAllLink(url, resultsQuantity) {
    var a = document.createElement('a');
    a.classList.add('see-all');
    a.href = url;
    a.innerHTML = 'See all ' + resultsQuantity + ' results';
    return a;
  }

  showSearchingResults() {
    this.resultsVisible = true;
    if (!this.results.style.minHeight) {
      document.addEventListener('click', this.documentClickHandler);

      var height = this.results.offsetHeight;
      this.results.style.minHeight = Math.max(height, 80)  + 'px';
      this.results.innerHTML = '<div style="height: 100%;" class="loader-wrap flex justify-content-center align-items-center"><div class="loader"></div></div>';
    }
  }

  clearResults(removeEvents=true) {
    if(removeEvents) {
      document.removeEventListener('click', this.documentClickHandler);
      this.resultsVisible = false;
    }

    if (this.results){
      this.results.innerHTML = '';
      this.results.style.minHeight = ''; 
    }
  }

  noResults() {
    this.results.innerHTML = '<div class="no-results">No results</div>';
  }

  documentClick(e) {
    if(!this.contains(e.target)) {
      this.clearResults();
    }
  }
}
customElements.define('search-form', ComponentSearch);